import { render, staticRenderFns } from "./DetalhesLotesItens.vue?vue&type=template&id=401d0740&scoped=true"
import script from "./DetalhesLotesItens.vue?vue&type=script&lang=ts"
export * from "./DetalhesLotesItens.vue?vue&type=script&lang=ts"
import style1 from "./DetalhesLotesItens.vue?vue&type=style&index=1&id=401d0740&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401d0740",
  null
  
)

export default component.exports